document.addEventListener('DOMContentLoaded', function() {
  // Active cat nav
  var path = window.location.pathname;
  document.querySelectorAll('.cat-nav-item').forEach(function(l) {
    if (l.getAttribute('href') && path.startsWith(l.getAttribute('href'))) {
      l.style.color = '#FF0080';
      l.style.borderBottomColor = '#FF0080';
    }
  });
  // Cart qty auto-submit
  document.querySelectorAll('.cart-qty').forEach(function(input) {
    input.addEventListener('change', function() {
      input.closest('form').submit();
    });
  });
});
